<template>
  <form-field
    :label="label"
    :data-qa="dataQa"
    :class="$props.class"
    :style="style"
  >
    <template #default="{ id }">
      <base-datepicker
        v-bind="$attrs"
        :id="id"
      />
    </template>
  </form-field>
</template>

<script>
import BaseDatepicker from '@/components/base-datepicker/index.vue';
import FormField from '@/shared/legacy/ui/form-field/form-field.vue';

export default {
  name: 'FormDatepicker',
  components: {
    FormField,
    BaseDatepicker
  },
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: undefined
    },
    dataQa: {
      type: String,
      default: undefined
    },
    class: {
      type: [String, Array, Object],
      default: undefined
    },
    style: {
      type: [String, Array, Object],
      default: undefined
    }
  }
};
</script>

<i18n lang="json">{}</i18n>
